module.exports = __webpack_public_path__ + "img/submission-portal-hero.e4a0bef3.png";